"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const state_1 = __importDefault(require("../state"));
const getCootsScreenCoords_1 = __importDefault(require("./getCootsScreenCoords"));
const getLaserPower = () => {
    if (state_1.default.hasMouseScreenCoords()) {
        const cootsScreenCoords = (0, getCootsScreenCoords_1.default)();
        const distance = Math.sqrt(Math.pow(state_1.default.mouseScreenCoords.x - cootsScreenCoords.x, 2) + Math.pow(state_1.default.mouseScreenCoords.y - cootsScreenCoords.y, 2));
        const maxDistance = Math.min(gameWidth_1.default, gameHeight_1.default) / 2;
        return Math.min(distance / maxDistance, 1);
    }
    return 0;
};
exports.default = getLaserPower;
